export enum TabRoutes {
    BaseRoute = '/:shopId(\\d+)',
    Welcome = '/welcome',
    Actual = '/actual',
    Financial = '/financial',
    Community = '/community',
    More = '/more',
}